/* Stav telefonu: kdy se lide dovolaji.

   Proc to nepocita Liquid: Shopify stranky kesuje, takze by se stav ustalil
   na okamziku, kdy se stranka vykreslila, a visel tam klidne do druheho dne.

   Proc to nepocita new Date() primo: to by bral hodiny navstevnika. Clovek
   v Londyne by v 17:30 sveho casu videl „zavreno“, i kdyz v Praze je 18:30,
   a naopak. Cas si proto vzdy prepocitame do Evropy/Prahy. */

class TbPhoneStatus extends HTMLElement {
  connectedCallback() {
    this.from = Number(this.dataset.from);
    this.to = Number(this.dataset.to);
    this.weekdaysOnly = this.dataset.weekdays !== 'false';
    this.isButton = this.classList.contains('tb-phone--button');
    this.stateNode = this.querySelector('[data-tb-phone-state]');

    if (!Number.isFinite(this.from) || !Number.isFinite(this.to)) return;

    this.update = this.update.bind(this);
    this.update();

    /* Minutovy takt, aby stranka nechana otevrena pres hranici otviraci
       doby neukazovala starou tecku. */
    this.timer = setInterval(this.update, 60000);
    document.addEventListener('visibilitychange', this.update);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.update);
  }

  /** Aktualni den a hodina v Praze, at uz je navstevnik kdekoli. */
  pragueNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Prague',
      weekday: 'short',
      hour: 'numeric',
      hour12: false,
    }).formatToParts(new Date());

    const value = (type) => {
      const found = parts.find((part) => part.type === type);
      return found ? found.value : '';
    };

    return {
      weekday: value('weekday'),
      /* Nektere prohlizece vrati o pulnoci 24 misto 0. */
      hour: Number(value('hour')) % 24,
    };
  }

  update() {
    if (document.hidden) return;

    const { weekday, hour } = this.pragueNow();
    const weekend = weekday === 'Sat' || weekday === 'Sun';
    const open = (!this.weekdaysOnly || !weekend) && hour >= this.from && hour < this.to;

    this.dataset.open = open ? 'true' : 'false';

    /* Tlacitko v hlavicce mimo dobu nenabizime vubec – nabizet hovor,
       ktery nikdo nezvedne, je horsi nez tlacitko neukazat. */
    if (this.isButton) this.hidden = !open;

    if (this.stateNode) {
      const text = open ? this.dataset.openText : this.dataset.closedText;
      if (text && this.stateNode.textContent !== text) this.stateNode.textContent = text;
    }
  }
}

if (!customElements.get('tb-phone-status')) {
  customElements.define('tb-phone-status', TbPhoneStatus);
}
